import { CashierMenuType } from "@/types/CashierProductType";
import CashierCard from "./CashierCard";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { Skeleton } from "../ui/skeleton";
import { useTranslation } from "react-i18next";

type CashierCardsListProps = {
  CashierMenuItems: CashierMenuType[];
  isLoading: boolean;
  isTables?: boolean;
};

function CashierCardsList({ CashierMenuItems, isLoading, isTables }: CashierCardsListProps) {
  const { t } = useTranslation();

  const items = CashierMenuItems?.flatMap((menu) => menu?.products ?? []);

  if (isLoading) {
    return (
      <div className="flex w-full flex-wrap gap-x-2 gap-y-[10px]">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton
            key={i}
            className="h-[130px] w-[170px] dark:bg-slate-600 dark:bg-opacity-35"
          />
        ))}
      </div>
    );
  }

  if (!items.length) {
    return (
      <Alert className="bg-skyblue dark:bg-skyblue text-sidebar dark:text-sidebar border-none dark:border-none">
        <AlertTitle className="text-xl text-center">
          {t("casheirCardList.noProductsTitle")}
        </AlertTitle>
        <AlertDescription className="text-center my-5 font-semibold">
          {t("casheirCardList.noProductsMessage")}
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="col-span-full flex w-full flex-wrap gap-x-2 gap-y-[10px] justify-start">
      {items.map((product, i) => (
        <CashierCard
          key={i}
          isTables={isTables}
          id={product._id}
          nameEN={product.nameEN}
          nameAR={product.nameAR}
          descriptionEN={product.descriptionEN}
          descriptionAR={product.descriptionAR}
          price={product.price}
          lowPrice={product.lowPrice}
          imageUrl={product.image}
          calories={product.calories}
          maxQuantity={product.quantity}
          options={product.options}
          addons={product.addons}
        />
      ))}
    </div>
  );
}

export default CashierCardsList;
